import { useState } from 'react';

export const AnnouncementStatusDropdown: React.FC<{
  initialStatus: string;
  onStatusChange?: (newStatus: string) => void;
}> = ({ initialStatus, onStatusChange }) => {
  const [status, setStatus] = useState(initialStatus);
  const [open, setOpen] = useState(false);

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'PUBLISHED':
        return '#177D3D';
      case 'EXPIRED':
        return '#891518';
      case 'SCHEDULED':
      default:
        return '#987D06';
    }
  };

  const options = [
    { label: 'Publish', value: 'PUBLISHED', color: '#177D3D' },
    { label: 'Expired', value: 'EXPIRED', color: '#891518' },
    { label: 'Scheduled', value: 'SCHEDULED', color: '#987D06' },
  ];

  const handleChange = (newStatus: string) => {
    setStatus(newStatus);
    setOpen(false);
    if (onStatusChange) onStatusChange(newStatus); // 🔥 notify parent
  };

  return (
    <div className="relative inline-block">
      {/* Dropdown trigger */}
      <div
        className="flex gap-2 items-center cursor-pointer select-none"
        onClick={() => setOpen((prev) => !prev)}
      >
        <p
          className="text-xl font-medium"
          style={{ color: getStatusColor(status) }}
        >
          {options.find((opt) => opt.value === status)?.label ?? 'Scheduled'}
        </p>

        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.00313 5.4002L0.203125 0.575195H9.80313L5.00313 5.4002Z"
            fill={getStatusColor(status)}
          />
        </svg>
      </div>

      {/* Dropdown menu */}
      {open && (
        <div className="absolute top-full left-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-md z-50">
          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => handleChange(opt.value)}
              className="px-4 py-2 cursor-pointer hover:bg-gray-100 flex items-center gap-2"
            >
              <span
                className="text-base font-medium"
                style={{ color: opt.color }}
              >
                {opt.label}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
